export default __webpack_public_path__ + "static/media/ChatBlack.888a9438.svg";